const KEY = 'hkshk-desk-queue';

export function readQueue() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || '[]');
  } catch (error) {
    return [];
  }
}

export function enqueue(item) {
  const rows = readQueue();
  rows.push({ ...item, client_id: `${Date.now()}-${rows.length}`, created_at: new Date().toISOString() });
  localStorage.setItem(KEY, JSON.stringify(rows));
  return rows.length;
}

export async function flushQueue(sender) {
  const pending = readQueue();
  const left = [];
  for (const item of pending) {
    try {
      await sender(item);
    } catch (error) {
      const code = error.response?.data?.code;
      if (code === 'already_checked_in' || code === 'already_redeemed') {
        continue;
      }
      if (!error.response) {
        left.push(item);
      }
    }
  }
  localStorage.setItem(KEY, JSON.stringify(left));
  return left.length;
}
